import React from "react";
import { cn } from "~/utils/fontsConfig";

export const PageWrapper = ({
    children,
    className,
}: {
    children: React.ReactNode;
    className?: string;
}) => {
    return (
        <main className="flex w-full justify-center self-start">
            <section
                className={cn(
                    "mt-2 w-full max-w-mobile md:max-w-desktop md:!pt-0",
                    className,
                )}
            >
                {children}
            </section>
        </main>
    );
};
